/**
 * Automatically redirect the user if a rejected action contains a redirect_url.
 * If an error message is provided, a "notice" query parameter is appended with the encoded error
 * which may be used to show a flash message to the user on the client-side
 * @see policy_submission_lock.rb (backend logic)
 * @see Dashboard/Components/DashboardNotice.tsx (client logic)
 */
export const redirectOnErrorMiddleware = (_store) => (next) => (action) => {
  // Only consider actions with types ending in '/rejected'
  if (action.type?.endsWith("/rejected")) {
    const errorData = action.payload?.data;
    if (errorData?.redirect_url) {
      const { redirect_url, error: errorMessage } = errorData;

      // Build a new URL by appending the "notice" query parameter if an error message exists.
      let newUrl = redirect_url;
      if (errorMessage) {
        const encodedNotice = encodeURIComponent(errorMessage);
        // Append with the correct separator: if there are already query parameters, use '&', otherwise '?'
        const separator = newUrl.includes("?") ? "&" : "?";
        newUrl = `${newUrl}${separator}notice=${encodedNotice}&severity=warning`;
      }

      // eslint-disable-next-line no-console
      console.info(`Redirecting to ${newUrl} due to error: ${errorMessage}`);

      window.location.href = newUrl;
    }
  }
  return next(action);
};
